import { Col, Row, Typography } from "antd";
import FormInput from "components/FormInput";
import { INPUT_TYPE } from "config/constants";
import { isNil } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";

const PriceInfo = ({ form, disabledInput, productGroupData }) => {
  const { t } = useTranslation();

  const [isTaxablePercentVAT, setIsTaxablePercentVAT] = useState(
    productGroupData?.products?.[0]?.vatPercent !== undefined
      ? [-1, 0, 3, 5, 8, 10].includes(productGroupData?.products?.[0]?.vatPercent)
      : -1
  );

  const inputOptionsPrices = {
    min: 0,
    maxLength: 11,
    style: { width: "100%" },
    addonAfter: <div className="add-on-after">đ</div>,
    disabled: disabledInput,
  };

  const optionVatPercent = [
    { value: 8, label: "8%" },
    { value: 10, label: "10%" },
    { value: 0, label: "0%" },
    { value: 3, label: "3%" },
    { value: 5, label: "5%" },
    { value: -1, label: t("v2.product.drawer_edit_product.not_taxable") },
    { value: "OTHER", label: "Khác" },
  ];

  return (
    <div className="price-info-container">
      <Row justify="start" gutter={32} className="price-info-row">
        <Col span={12}>
          <FormInput
            type={INPUT_TYPE.CURRENCY_INPUT}
            formItemOptions={{
              name: ["productPrices", "importPrice"],
              label: <span className="title">{t("product.productForm.costPrice")}</span>,
            }}
            inputOptions={{
              ...inputOptionsPrices,
              placeholder: t("product.productForm.costPrice"),
            }}
          />
        </Col>
        <Col span={12}>
          <FormInput
            type={INPUT_TYPE.CURRENCY_INPUT}
            formItemOptions={{
              name: ["productPrices", "price"],
              initialValue: 0,
              label: <span className="title">Giá có VAT</span>,
              rules: [
                {
                  validator: (_, value) => {
                    const hasValue = !isNil(value) && (typeof value === "string" ? value.trim() !== "" : true);
                    if (form.getFieldValue("hasVariant") || hasValue) return Promise.resolve();
                    return Promise.reject(new Error("Không được để trống trường này"));
                  },
                },
              ],
              preserve: false,
            }}
            inputOptions={{
              ...inputOptionsPrices,
              placeholder: "Nhập giá có VAT",
            }}
          />
        </Col>

        <Col span={12}>
          <Row className="vat-value-group" gutter={12}>
            <Col span={12}>
              <FormInput
                type={INPUT_TYPE.SELECT}
                formItemOptions={{
                  rules: [
                    {
                      validator: (_, value) => {
                        if (form.getFieldValue("hasVariant") || value !== undefined) return Promise.resolve();
                        return Promise.reject(new Error("Vui lòng chọn loại % VAT"));
                      },
                    },
                  ],
                  name: "taxablePercentVAT",
                  label: <Typography.Text strong>Loại % VAT</Typography.Text>,
                  preserve: false,
                }}
                inputOptions={{
                  options: optionVatPercent,
                  placeholder: "Nhập loại % VAT",
                  onChange: (value) => {
                    setIsTaxablePercentVAT([-1, 0, 3, 5, 8, 10].includes(value));
                  },
                }}
              />
            </Col>
            <Col span={12}>
              <FormInput
                type={INPUT_TYPE.NUMBER}
                key={isTaxablePercentVAT}
                formItemOptions={{
                  rules: [
                    {
                      validator: (_, value) => {
                        if (form.getFieldValue("hasVariant") || isTaxablePercentVAT || value !== undefined) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Không được để trống trường này"));
                      },
                    },
                  ],
                  name: "vatPercent",
                  className: "vat",
                  preserve: false,
                }}
                inputOptions={{
                  min: 0,
                  max: 100,
                  addonAfter: <div className="add-on-after">%</div>,
                  placeholder: t("product.productForm.percentVATPlaceholder"),
                  disabled: isTaxablePercentVAT,
                  maxLength: 2,
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default PriceInfo;
